import { attempt } from "@omni/utils/function.utils";
import { isDefined } from "@omni/utils/helper.utils";
import { entries, fromEntries } from "@omni/utils/object.utils";

import BreakpointsService, {
    BreakpointMinSizes
} from "@/services/breakpoint.service";

// TODO - Typing of functions
export type LayoutSettings = Partial<
    Record<
        BreakpointMinSizes,
        {
            slidesPerView: number | "auto";
            slidesPerGroup?: number;
            direction?: "horizontal" | "vertical";
        }
    >
>;

export type EffectiveLayoutSettings = Record<
    number,
    {
        slidesPerView: number | "auto";
        slidesPerGroup?: number;
        direction?: "horizontal" | "vertical";
    }
>;

export const determineSlidesPerView = (breakpoints: any) => {
    const breakPointsSettings: any = {};
    breakpoints.map((breakpoint: any) => {
        breakPointsSettings[
            BreakpointsService.getBreakpointMinValues(breakpoint.breakpoint)
        ] = {
            direction: breakpoint.direction,
            slidesPerView: breakpoint.slides
        };
    });

    return breakPointsSettings;
};

/**
 * Parse the settings to JSON
 * Replace the breakpoint aliases with the actual breakpoint values
 */
export const getEffectiveLayoutSettings = (
    originalSettings: LayoutSettings
): EffectiveLayoutSettings => {
    if (!originalSettings) return {};

    const parsedSettings =
        typeof originalSettings === "string"
            ? attempt<LayoutSettings | null>(
                  () => JSON.parse(originalSettings),
                  null
              )
            : originalSettings;

    if (!isDefined(parsedSettings)) return {};

    return fromEntries(
        entries(parsedSettings)
            .map(([breakpoint, value]) =>
                !isDefined(value) ? undefined : ([breakpoint, value] as const)
            )
            .filter(isDefined)
            .map(([breakpoint, value]) => [
                BreakpointsService.getBreakpointMinValues(breakpoint),
                value
            ])
    );
};

const toSrrLayoutClass = (
    breakpoint: BreakpointMinSizes,
    slidesPerView: number | "auto"
) => {
    return `slider-layout-${breakpoint}-${slidesPerView.toString().replace(".", "_")}`;
};

export const mapSsrLayoutClasses = (layoutSettings: LayoutSettings) => {
    return entries(layoutSettings)
        .map(([breakpoint, value]) =>
            !isDefined(value) ? undefined : ([breakpoint, value] as const)
        )
        .filter(isDefined)
        .reduce<Array<string>>(
            (acc, [breakpoint, { slidesPerView }]) => [
                ...acc,
                toSrrLayoutClass(breakpoint, slidesPerView)
            ],
            []
        )
        .join(" ");
};

export default determineSlidesPerView;
